<template>
  <div class="news-list bg-light pb-5">
    <div
            class="top jumbotron jumbotron-fluid mb-2"
            :style="{ backgroundImage: 'url(' + backgroundUrl + ')' }"
    >
      <div class="container text-danger">
        <h1 class="animated fadeInDown">群组信息</h1>
        <p class="animated fadeInDown">—— {{ sectionSubTitle }} ——</p>
      </div>
    </div>
    <div class="container content mt-5">
      <!-- 当前位置 -->
      <div class="text-right position mb-3 d-none d-md-block text-muted">
        当前位置：
        <router-link to="/toHome" class="text-muted">首页</router-link>
        /
        <a href="#" class="text-muted">群组信息</a>
      </div>
      <h3 class="text-center text-danger font-weight-bold wow fadeInDown">
        群组
        <img
                :src="titleImgUrl"
                alt="logo"
                width="50"
                height="50"
                class="rounded-circle mx-2"
        />
        信息
      </h3>
      <div class="text-center mb-4 text-secondary wow fadeInUp">
        —— {{sectionSubTitle}} ——
      </div>
      <div class="phone-game-list row">
        <div class="col-sm-12 col-md-12 col-lg-6 my-2"
             v-for="(item, index) in groupList"
             :key="index"
        >
          <div
                  class="bg-white list-item myGutter"
          >
            <div class="info col-9">
              <!--<div class="info col-9 ml-2">-->
              <div class="game-name font-weight-bold">
                {{ item.groupDes }}
              </div>
              <div class="game-info">{{ item.groupNum }}</div>
            </div>
            <div class="button-div flex-fill">
              <button
                      class="btn btn-outline-success"
                      @click="copyStr(item.groupNum)"
                      :data-clipboard-text="item.groupNum"
                      v-if="isPC ||isAndroid"
              >
                复制号码
              </button>
              <button
                      class="btn btn-outline-danger"
                      @click="copyStr(item.groupNum)"
                      :data-clipboard-text="item.groupNum"
                      v-if="isIOS"
              >
                复制号码
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import { WOW } from "wowjs";
export default {
  name: "QqGroup",
  data() {
    return {
      backgroundUrl: "",
      titleImgUrl: "",
      sectionSubTitle: "",
      logSys: 1,
      isPC: false,
      isAndroid: false,
      isIOS: false,
      moreImgUrl: "",
      groupList: [
        {
          id: 1,
          groupDes: "",
          groupNum: 0
        }
      ]
    };
  },
  mounted() {
    let options = { live: false };
    new WOW(options).init();
    this.isSystem();
    this.getNavById();
    this.getGroupList();
  },
  methods: {
    isSystem() {
      if (navigator.userAgent.match("Android")) {
        this.isAndroid = true;
        this.logSys = 2;
      } else if (navigator.userAgent.match("iPhone")) {
        this.isIOS = true;
        this.logSys = 3;
      } else if (navigator.userAgent.match("iPad")) {
        this.isIOS = true;
        this.logSys = 3;
      } else {
        this.isPC = true;
        this.logSys = 1;
      }
    },
    getNavById() {
      this.axios
              .get("/navigation/getNavById/" + 9)
              .then(resp => {
                if (resp && resp.data.code === 10000 && resp.data.success) {
                  this.titleImgUrl = resp.data.data.titleImg;
                  this.sectionSubTitle = resp.data.data.subTitle;
                  this.moreImgUrl = resp.data.data.moreImgUrl;
                  this.backgroundUrl = resp.data.data.bannerImg;
                }
              })
              .catch();
    },
    getGroupList() {
      this.axios
        .get("/gameGroupInfo/getAll")
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            console.log(resp.data.data);
            this.groupList = resp.data.data;
          }
        })
        .catch();
    },
    //    复制文本
    copyStr(str) {
      // this.copyContent = this.$refs.copytext.innerText;//也可以直接写上等于你想要复制的内容
      this.copyContent = str; //也可以直接写上等于你想要复制的内容
      const input = document.createElement("input"); // 直接构建input
      input.value = this.copyContent; // 设置内容
      console.log(input.value);
      document.body.appendChild(input); // 添加临时实例
      input.select(); // 选择实例内容
      document.execCommand("Copy"); // 执行复制
      document.body.removeChild(input); // 删除临时实例
      this.$message.success("复制成功");
      // alert("复制成功");
    }
  }
};
</script>

<style scoped lang="scss">
  .news-list {
    min-height: 600px;
  margin-top: 67px;
  .container {
    .phone-game-list {
      .list-item {
        border-radius: 5px;
        padding: 10px 5px;
        /*width: 100%;*/
        display: flex;
        flex-wrap: nowrap;
      }
      .info {
        /*width: 60%;*/
        height: 40px;
        padding: 0 10px;
        display: -webkit-box;
        /*-webkit-line-clamp: 1;*/
        -webkit-box-orient: vertical;
        .badge {
          line-height: 1.5;
        }
        .game-name {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space:nowrap;
        }
        .game-info {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space:nowrap;
          font-size: 12px;
        }
      }

      .button-div {
        padding-right: 8px;
        width: 70px;
        height: 40px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        button {
          font-size: 12px;
        }
      }
    }
  }
  .top {
    background: no-repeat center;
    width: 100%;
    background-size: cover;
  }

  .content {
    .row {
      div {
        .card:hover {
          box-shadow: 0 0 0.5rem rgba(255, 83, 10, 0.6);
          border-radius: 0;
        }

        .card-title {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .news-summary {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    .el-divider__text {
      background-color: #f8f9fa;
    }
  }
}
</style>
